import Vue from 'vue'

const files = require.context('./filters', true, /\.js$/)


files.keys().forEach(key => {
  let obj = files(key).default
  let keyObj = Object.keys(obj)[0],
    value = Object.values(obj)[0]
  Vue.filter(keyObj, value)
})
